'use client'

import BrokenPage from '@/components/ui/errors/500'

export default function NotFound() {
  return (
    <BrokenPage />
  )
}